import { render, staticRenderFns } from "./LyricsStoreLogos.vue?vue&type=template&id=336a3426&scoped=true&"
import script from "./LyricsStoreLogos.vue?vue&type=script&lang=js&"
export * from "./LyricsStoreLogos.vue?vue&type=script&lang=js&"
import style0 from "./LyricsStoreLogos.vue?vue&type=style&index=0&id=336a3426&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336a3426",
  null
  
)

export default component.exports